import React,  { useState } from 'react';
import ModalSzamlazasiAdatok from './modals/ModalSzamlazasiAdatok';

import 'bootstrap/dist/css/bootstrap.min.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

// A számlázási adatok megjelenítése és szerkesztése. A vevo csak az első mentéskor jön létre,
// addig a `vevo` null, és az adatok megadása kötelező a fizetéshez.
export default function SzamlazasiAdatokDisplay({felhasznalo, onSave, ...props}) {
    const [modalShown_szamlazasiAdatok, setModalShown_szamlazasiAdatok] = useState(false);
    const vevo = felhasznalo.vevo;
    const teljes = felhasznalo.szamlazasiAdatokTeljesek;

    function onClick_adatok_megadasa(){
        setModalShown_szamlazasiAdatok(true)
    }

    function onSave_szamlazasi_adatok(ujFelhasznalo){
        onSave(ujFelhasznalo)
        setModalShown_szamlazasiAdatok(false)
    }

    function onHide_modal_szamlazasi_adatok(){
        setModalShown_szamlazasiAdatok(false)
    }

    return (
        <div className="szamlazasiAdatokDisplay">
            <div className="cimTitle">Számlázási adatok</div>
            {teljes ?
                <div className="body">
                    <div className="cegnevSzemelynev">{vevo.Ceg ? vevo.Cegnev : vevo.Szemelynev}</div>
                    <div className="irszTelepules">{vevo.Irsz} {vevo.Telepules}</div>
                    <div className="cim">{vevo.Cim}</div>
                    {vevo.Ceg ?
                        <div className="adoszam">Adószám: <span>{vevo.Adoszam}</span></div>
                        : undefined
                    }
                    <br />
                    <div className="btnEdit masodlagos" onClick={onClick_adatok_megadasa}>
                        <div className="icon"><FontAwesomeIcon icon="fa-pencil" /></div>
                        <div className="text">Adatok szerkesztése</div>
                    </div>
                </div>
                :
                <div className="btnEdit" onClick={onClick_adatok_megadasa}>
                    <div className="icon"><FontAwesomeIcon icon="fa-pencil" /></div>
                    <div className="text">Számlázási adatok megadása</div>
                </div>
            }
            <ModalSzamlazasiAdatok
                vevo={vevo}
                teljes={teljes}
                alapNev={felhasznalo.Nev}
                show={modalShown_szamlazasiAdatok}
                callAPI={props.callAPI}
                onSave={onSave_szamlazasi_adatok}
                onHide={onHide_modal_szamlazasi_adatok}
            />
        </div>
    )
}
